import React from "react";
import { ToggleSuppressionTypeDialogProps } from "./ToggleSuppressionTypeDialog";
import { useToggleSuppressionTypeMutation } from "@tiny/api";

export function useToggleSuppressionTypeDialog(
  props: ToggleSuppressionTypeDialogProps
) {
  const { onSuccess, suppression } = props;

  const {
    mutateAsync: toggleSuppressionTypeMutateAsync,
    isLoading: isToggleSuppressionTypeLoading,
  } = useToggleSuppressionTypeMutation();

  const toggleSuppressionType = React.useCallback(async () => {
    await toggleSuppressionTypeMutateAsync({
      suppressionId: suppression.id || "",
      scope: suppression.scope === "LOCAL" ? "GLOBAL" : "LOCAL",
    });
    onSuccess();
  }, [
    onSuccess,
    suppression.id,
    suppression.scope,
    toggleSuppressionTypeMutateAsync,
  ]);

  const loading = isToggleSuppressionTypeLoading;

  return {
    toggleSuppressionType,
    loading,
  };
}
